if (!customElements.get('related-product-cart-section')) {
  customElements.define(
    'related-product-cart-section',
    class RelatedProductCartSection extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      refresh() {
        fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newSection = html.querySelector(
              `related-product-cart-section[data-section-id="${this.sectionId}"]`
            );
            if (newSection) {
              this.replaceWith(newSection);
            } else {
              this.remove();
            }
          })
          .catch((error) => console.error('related-product-cart-section refresh failed', error));
      }
    }
  );
}
